import {useState, useEffect} from 'react';

/**
 * Custom hook to manage local UI state for the Files page
 */
export const useFilesState = (globalSelectedResource, availableResources) => {
  // Search and filters
  const [search, setSearch] = useState('');
  const [scope, setScope] = useState('resource');
  const [selectedResource, setSelectedResource] = useState(globalSelectedResource?.id || '');

  // File upload state
  const [filesPage, setFilesPage] = useState(1);
  const [filesPerPage, setFilesPerPage] = useState(3);

  // Export request state
  const [exportType, setExportType] = useState('historical_forecast');
  const [exportStartDate, setExportStartDate] = useState('');
  const [exportEndDate, setExportEndDate] = useState('');
  const [exportMessage, setExportMessage] = useState('');
  const [targetUserId, setTargetUserId] = useState(null);
  const [selectedHorizon, setSelectedHorizon] = useState(null);
  const [includeEnsemble, setIncludeEnsemble] = useState(false);
  const [ensembleModel, setEnsembleModel] = useState('weighted_avg');
  const [anonymize, setAnonymize] = useState(false);
  const [paymentFilter, setPaymentFilter] = useState('all');
  const [pendingRequests, setPendingRequests] = useState([]);

  // Exports list state
  const [exportsPage, setExportsPage] = useState(1);
  const [exportsPerPage, setExportsPerPage] = useState(5);
  const [exportsFilterType, setExportsFilterType] = useState('all'); // Filter by export type

  // Sync selected resource with global. A new resource may expose a different
  // set of horizons, so clear any prior horizon selection.
  useEffect(() => {
    const newId = globalSelectedResource?.id || (availableResources && availableResources[0]?.id) || '';
    setSelectedResource(newId);
    setSelectedHorizon(null);
  }, [globalSelectedResource, availableResources]);

  return {
    // Search and filters
    search,
    setSearch,
    scope,
    setScope,
    selectedResource,
    setSelectedResource,

    // Files pagination
    filesPage,
    setFilesPage,
    filesPerPage,
    setFilesPerPage,

    // Export request
    exportType,
    setExportType,
    exportStartDate,
    setExportStartDate,
    exportEndDate,
    setExportEndDate,
    exportMessage,
    setExportMessage,
    targetUserId,
    setTargetUserId,
    selectedHorizon,
    setSelectedHorizon,
    includeEnsemble,
    setIncludeEnsemble,
    ensembleModel,
    setEnsembleModel,
    anonymize,
    setAnonymize,
    paymentFilter,
    setPaymentFilter,
    pendingRequests,
    setPendingRequests,

    // Exports pagination
    exportsPage,
    setExportsPage,
    exportsPerPage,
    setExportsPerPage,

    // Exports filter
    exportsFilterType,
    setExportsFilterType,
  };
};

